import { LifeCycleEventName } from "../constants/sdk";
class BasePlugin {
  getName() {
    return this.constructor.name;
  }
  getLifeCycleEvents() {
    return Object.values(LifeCycleEventName).filter((event) => {
      return typeof (this == null ? void 0 : this[event]) === "function";
    });
  }
}
var BasePlugin_default = BasePlugin;
export {
  BasePlugin_default as default
};
